import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import { transformLineItemToBE } from '../../../../../../formatters/transformLineItemToBE'

import { createGamLineItemForecastService } from '../../../../../../../../../../../modules/services/googleAdManager'
import { gamRightUploadAdDataSelector, rightSelector } from '../../../../../../../../../../../modules/selectors/rights'
import { selectedPartnershipSelector } from '../../../../../../../../../../../modules/selectors/partnerships'
import { selfAccountSelector } from '../../../../../../../../../../../modules/selectors/selfAccounts'

import { GOOGLE_AD_MANAGER_AD_ACCOUNT } from '../../../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'
import { GAM_NETWORK_CODE } from '../../../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/fields'

export const useFetchLineItemForecast = ({ values, inventory, microAmount, units }) => {
  const right = useSelector(rightSelector)
  const { campaign } = useSelector(gamRightUploadAdDataSelector)
  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const selfAccount = useSelector(selfAccountSelector)

  const campaignId = campaign?.id
  const currency = selectedPartnership[GOOGLE_AD_MANAGER_AD_ACCOUNT].currency
  const { [GOOGLE_AD_MANAGER_AD_ACCOUNT]: gamAccount } = selectedPartnership
  const gamAccountId = gamAccount?.external_id
  const gamNetworkCode = selfAccount?.[GAM_NETWORK_CODE]

  const lineItem = useMemo(() => {
    return transformLineItemToBE({
      inventory,
      values,
      campaignId,
      units,
      microAmount,
      right,
      currency
    })
  }, [inventory, values, campaignId, units, microAmount, right, currency])

  const forecastRequestData = useMemo(() => {
    return {
      network_code: gamNetworkCode,
      line_item: {
        line_item: lineItem,
        advertiser_id: gamAccountId
      }
    }
  }, [lineItem, gamAccountId, gamNetworkCode])

  const { data, error, isLoading } = useQuery({
    queryKey: ['lineItemForecast', units, inventory?.length],
    queryFn: () => createGamLineItemForecastService(forecastRequestData),
    enabled: !!units && units > 0 && !!microAmount,
    retry: false
  })

  return {
    data,
    error,
    isLoading
  }
}
